/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductInverterList } from '../models/PaginatedProductInverterList';
import type { PatchedProductInverter } from '../models/PatchedProductInverter';
import type { ProductInverter } from '../models/ProductInverter';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsInvertersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductInverterList
     * @throws ApiError
     */
    public productsInvertersList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductInverterList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-inverters/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductInverter
     * @throws ApiError
     */
    public productsInvertersCreate({
        requestBody,
    }: {
        requestBody: ProductInverter,
    }): CancelablePromise<ProductInverter> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-inverters/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductInverter
     * @throws ApiError
     */
    public productsInvertersRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product inverter.
         */
        id: number,
    }): CancelablePromise<ProductInverter> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-inverters/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductInverter
     * @throws ApiError
     */
    public productsInvertersUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product inverter.
         */
        id: number,
        requestBody: ProductInverter,
    }): CancelablePromise<ProductInverter> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-inverters/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductInverter
     * @throws ApiError
     */
    public productsInvertersPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product inverter.
         */
        id: number,
        requestBody?: PatchedProductInverter,
    }): CancelablePromise<ProductInverter> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-inverters/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsInvertersDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product inverter.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-inverters/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
